// import React from "react";
import { render } from "react-dom";
import "@smartsuite/react-ui/lib/styles.sass";
import "@smartsuite/smartdoc/lib/esm/styles.sass";
// In the product the host app loads these globally, as it does the two above.
import "@smartsuite/flash-notifications/lib/flash-notifications/styles.sass";

import { Demo } from "./Demo";

render(<Demo />, document.getElementById("root"));
